import { useGlobalContext } from '../../../../services/context.service';
import React, { lazy, Suspense, useEffect, useMemo, useState } from 'react';
import { getColumns, getColumns1 } from './columns';
import { Grid, Typography, useMediaQuery } from '@mui/material';
import { fnLocalizeFilter } from '../../../../services/localize.service';
import { styled } from '@mui/material/styles';
import InputSearchLine from '../../../UI/Input/InputSearchLine';
import { holderAPI } from '../../../../services/holderAPI.service';
import { getMedia } from '../../../../helpers/media';
import { filterObject } from '../../../../utils/methods';
import { IHolders } from '../../../../services/response.interface';
import Loading from '../../../UI/Loading/Loading';
import { useTheme } from '@mui/styles';
import CustomTable from '../../../UI/CustomTable';
import { IFilter, IOrderBy } from '../../../UI/CustomTable/interface/interface.custom';
import { useAppDispatch } from '../../../../hooks/redux';
import { COUNT_PER_ON_PAGE } from '../../../../helpers/api';

const ClientDetail = lazy(() => import('../ClientDetail/ClientDetail'));

const Container = styled(Grid)(() => ({
  display: 'flex', flexDirection: 'column', overflow: 'hidden', position: 'absolute',
}));

const TitleClient = styled(Typography)((props) => {
  return ({
    fontSize: '2rem', fontWeight: 500, margin: '3rem 2rem', [props.theme.breakpoints.down('md')]: {
      margin: '1rem 1rem',
    },
  });
});


/* Кол-во строк в таблице */
const countPerOnPage: number = COUNT_PER_ON_PAGE ? +COUNT_PER_ON_PAGE : 5;

export default function ClientList() {
  /* Получаем языковую локаль */
  const { locale } = useGlobalContext();

  const theme = useTheme();

  /* Инициализация медиа  */
  const matches = useMediaQuery(getMedia());

  /* Флаг показа детального описание клиента  */
  const [isOpenDetail, setOpenDetail] = useState<boolean>(false);

  /* Получаем список клиентов доступных пользователю */
  const [getHolders, { data = { holders: [] }, isLoading }] = holderAPI.useLazyFetchAllClientsQuery();

  useEffect(() => {
    getHolders({ locale });
  }, []);

  /* Выбранный клиент */
  const [selectedClient, setSelectedClient] = useState<IHolders | undefined>();

  /* Заполняем табличные заголовки */
  const columns1 = useMemo(() => {
    return getColumns1(locale, theme);
  }, [locale, theme]);

  /* Строка поиска по всем полям таблицы */
  const [searchStr, setSearchStr] = useState('');

  const [pageNum, setPage] = useState<number>(0);
  /* Если меняем клиента обновляем таблицу счетов */
  useEffect(() => {
    setPage(0);
  }, []);

  /* Управление состоянием */
  const dispatch = useAppDispatch();

  /* Фильтр по столбцам таблицы  */
  const rows1 = useMemo(() => {
    const filteredObj = filterObject({ arr: data?.holders, fields: ['name', 'okpo', 'itn', 'phone'], searchStr });

    /* Обрезаем массив до необходимых размеров отображения на странице */
    const startRow = pageNum === 0 ? 0 : (pageNum * countPerOnPage);
    const stopRow = (pageNum + 1) * countPerOnPage;

    return filteredObj.slice(startRow, stopRow);

  }, [data.holders, searchStr, pageNum]);

  const handleDoubleClick = (holders: IHolders) => {
    setSelectedClient(holders);
    setOpenDetail(true);
  };

  const language = useMemo(() => {
    switch (locale) {
      case 'uk' :
        return 'uk';
      case 'en' :
        return 'US';
      case 'ru' :
        return 'ru';
    }
  }, [locale]);

  const handleChangePage1 = (filter: any, sorting: any) => {
    setPage(sorting.pageNum - 1);
  };

  /* Текущая страница счетов */
  const [orderBy, setOrderBy] = useState<IOrderBy>({ field: '', order: 'asc' });
  const handleChangePage = ({ page, orderBy }: IFilter) => {
    setOrderBy(orderBy);
    setPage(page - 1);
  };

  /* Заполняем табличные заголовки */
  const columns = useMemo(() => {
    return getColumns({ locale, holders: data.holders, dispatch });
  }, [data.holders, dispatch, locale]);


  /* Фильтр по столбцам таблицы  */
  const rows = useMemo(() => {
    let count = 0;
    /* Применение фильтра */
    let filteredObj = filterObject({ arr: data?.holders, fields: ['name', 'okpo', 'itn', 'phone'], searchStr });

    count = filteredObj.length;

    /* Обрезаем массив до необходимых размеров отображения на странице */
    const startRow = pageNum === 0 ? 0 : (pageNum * countPerOnPage);
    const stopRow = (pageNum + 1) * countPerOnPage;

    /* Обрезаем по строкам на странице после фильтра */
    filteredObj = filteredObj.slice(startRow, stopRow);

    return { arr: filteredObj, count };

  }, [data.holders, searchStr, pageNum]);


  return <>
    <Container container>
      <Grid>
        <InputSearchLine placeholder={fnLocalizeFilter(locale, '_lang.module.common.title.titleSearchStr')}
                         onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                           setSearchStr(e.currentTarget.value);
                         }} />
      </Grid>

      <Grid>
        <TitleClient>{fnLocalizeFilter(locale, '_lang.module.clientList.titlePage')}</TitleClient>
      </Grid>

      <Grid item xs={9}>

        <CustomTable
          rows={rows.arr}
          columns={columns}
          isLoading={isLoading}
          count={rows.count}
          labelEmptyRows={fnLocalizeFilter(locale, '_lang.module.clientList.titlePage')}
          rowsPerPageOptions={[countPerOnPage]}
          fnRefreshData={handleChangePage}
          onDoubleClick={handleDoubleClick}
        />

      </Grid>

    </Container>

    {

      isOpenDetail && <Suspense fallback={<Loading type={'fullScreen'} />}>
        <ClientDetail
          open={isOpenDetail}
          detailClient={selectedClient as IHolders}
          handleClose={() => setOpenDetail(false)}
        />
      </Suspense>}

  </>;
}
